<script setup>
import { ref } from 'vue';

const emit = defineEmits(['update:modelValue', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const statuses = [
    { title: 'Verified', value: 'Verified' },
    { title: 'Not Verified', value: 'Not Verified' },
    { title: 'Voided', value: 'Voided' },
    { title: 'Refunded', value: 'Refunded' }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="hideLabel ? '' : $t('Payment Status')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
